import {
  SET_VALID_FIELD,
  REMOVE_VALID_FIELD,
  SET_INVALID_FIELD,
  REMOVE_INVALID_FIELD,
  REMOVE_FIELDS_CORRECTNESS,
} from "features/application/field/redux/types";

export const setValidFieldAction = (name) => ({
  type: SET_VALID_FIELD,
  payload: name,
});

export const removeValidFieldAction = (name) => ({
  type: REMOVE_VALID_FIELD,
  payload: name,
});

export const setInvalidFieldAction = (name) => ({
  type: SET_INVALID_FIELD,
  payload: name,
});

export const removeInvalidFieldAction = (name) => ({
  type: REMOVE_INVALID_FIELD,
  payload: name,
});

export const removeFieldsCorrectnessAction = () => ({
  type: REMOVE_FIELDS_CORRECTNESS,
});
